export default "__VITE_ASSET__52a3ff43__"